import {Icon} from '@iconify/react';
import React, {useEffect, useState} from 'react';
import {useDebouncedCallback} from 'use-debounce';

interface SearchInputProps {
    placeholder: string | undefined;
    onSearch: ((searchTerm: string) => void) | undefined;
}
function SearchInput(props: SearchInputProps): JSX.Element {
    const {placeholder, onSearch} = props;

    const [searchTerm, setSearchTerm] = useState<string>('');

    const onSearchDebounced = useDebouncedCallback((searchTerm) => {
        if (onSearch) {
            onSearch(searchTerm);
        }
    }, 1000);

    useEffect(() => {
        if (onSearch) {
            onSearch(searchTerm);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="c-search">
            <label>
                <Icon icon="fa:search" className="search" />
                <input
                    data-cy="search"
                    className="e-input"
                    value={searchTerm}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setSearchTerm(e.target.value);
                        onSearchDebounced(e.target.value);
                    }}
                    type="text"
                    placeholder={placeholder && placeholder}
                />
            </label>
        </div>
    );
}

export default SearchInput;
